export const header = {
  profile: 'Mi Cuenta',
  shared: 'Compartidos',
  activity: 'Historial',
  balance: 'Balance',
  billing: 'Facturación',
  help: 'Ayuda',
  about: 'Sobre Space Guru',
  logOut: 'Cerrar sesión',
  community: 'Comunidad',
  myCatalog: 'Mis Ítems',
}

export const tabs = {
  community: 'Comunidad',
  myCatalog: 'Mis Ítems',
}

export const login = {
  button: 'Entrar',
}



// WEBPACK FOOTER //
// ./src/sections/header/text.js